import { Check } from "lucide-react";

export type WizardStep = { key: string; label: string };

type Props = {
  steps: WizardStep[];
  current: number;
};

export default function BundleWizardStepper({ steps, current }: Props) {
  const next = steps[current + 1];

  return (
    <div className="space-y-2">
      <div className="flex items-center">
        {steps.map((step, i) => {
          const done = i < current;
          const active = i === current;
          return (
            <div
              key={step.key}
              className="flex items-center flex-1 last:flex-none"
            >
              <div className="flex items-center gap-2 shrink-0">
                <div
                  className={`flex h-7 w-7 items-center justify-center rounded-full text-xs font-medium ${
                    done || active
                      ? "bg-sidebar text-white"
                      : "bg-gray-200 text-gray-500"
                  }`}
                >
                  {done ? <Check className="h-4 w-4" /> : i + 1}
                </div>
                <span
                  className={`text-sm ${
                    active ? "font-semibold text-gray-900" : "text-gray-500"
                  }`}
                >
                  {step.label}
                </span>
              </div>
              {i < steps.length - 1 && (
                <div
                  className={`mx-3 h-px flex-1 ${
                    i < current ? "bg-sidebar" : "bg-gray-200"
                  }`}
                />
              )}
            </div>
          );
        })}
      </div>
      <p className="text-xs text-gray-500">
        Step {current + 1} of {steps.length} · {steps[current].label}
        {next ? `  ·  Next → ${next.label}` : "  ·  Final step"}
      </p>
    </div>
  );
}
